var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm',{attrs:{"title":"退会","description":"退会処理が完了しました。ご利用頂き、ありがとうございました。","to":"login"}})}
var staticRenderFns = []

export { render, staticRenderFns }